import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import {
  bootIntercom,
  getIntercomAppId,
  loadIntercomWidget,
  updateIntercom,
} from "../utils/intercom";

export default function IntercomMessenger() {
  const appId = getIntercomAppId();
  const location = useLocation();
  const booted = useRef(false);

  useEffect(() => {
    if (!appId) {
      return;
    }

    if (!booted.current) {
      loadIntercomWidget(appId);
      bootIntercom(appId);
      booted.current = true;
      return;
    }

    // Keep Bea aware of the page the visitor is actually on.
    updateIntercom();
  }, [appId, location]);

  return null;
}
